import { Navigate } from "../../../../../router-utils"

export default function OrgTagsPage() {
	return <Navigate to={"/org/tags/trips"} replace />
}
